import * as type from "../types/new-template";

export const requestAddNewTemplate = (payload) => {
  return {
    type: type.REQUEST_ADD_NEW_TEMPLATE,
    details: payload,
  };
};

export const resetAddNewTemplate = () => {
  return {
    type: type.RESET_ADD_NEW_TEMPLATE,
  };
};

export const setNewTemplateType = (payload) => {
  return {
    type: type.SET_NEW_TEMPLATE_TYPE,
    variant: payload,
  };
};

export const resetNewTemplateType = () => {
  return {
    type: type.RESET_NEW_TEMPLATE_TYPE,
  };
};

export const setNewEmailTemplateTitle = (payload) => {
  return {
    type: type.SET_NEW_EMAIL_TEMPLATE_TITLE,
    title: payload,
  };
};

export const resetNewEmailTemplateTitle = () => {
  return {
    type: type.RESET_NEW_EMAIL_TEMPLATE_TITLE,
  };
};

export const setNewEmailTemplateContent = (payload) => {
  return {
    type: type.SET_NEW_EMAIL_TEMPLATE_CONTENT,
    content: payload,
  };
};

export const resetNewEmailTemplateContent = () => {
  return {
    type: type.RESET_NEW_EMAIL_TEMPLATE_CONTENT,
  };
};

export const setNewEmailTemplateHTMLContent = (payload) => {
  return {
    type: type.SET_NEW_EMAIL_TEMPLATE_HTML,
    html: payload,
  };
};

export const resetNewEmailTemplateHTMLContent = () => {
  return {
    type: type.RESET_NEW_EMAIL_TEMPLATE_HTML,
  };
};

export const setNewSmsTemplateTitle = (payload) => {
  return {
    type: type.SET_NEW_SMS_TEMPLATE_TITLE,
    title: payload,
  };
};

export const resetNewSmsTemplateTitle = () => {
  return {
    type: type.RESET_NEW_SMS_TEMPLATE_TITLE,
  };
};

export const setNewSmsTemplateMessage = (payload) => {
  return {
    type: type.SET_NEW_SMS_TEMPLATE_MESSAGE,
    message: payload,
  };
};

export const resetNewSmsTemplateMessage = () => {
  return {
    type: type.RESET_NEW_SMS_TEMPLATE_MESSAGE,
  };
};

export const setNewSmsTemplatePlaintext = (payload) => {
  return {
    type: type.SET_NEW_SMS_TEMPLATE_PLAINTEXT,
    message: payload,
  };
};

export const resetNewSmsTemplatePlaintext = () => {
  return {
    type: type.RESET_NEW_SMS_TEMPLATE_PLAINTEXT,
  };
};
